module.exports = __webpack_public_path__ + "img/01.c26b4100.jpg";